import styles from "./styles.module.scss";

const Shimmer = ({ width, height, borderRadius, style = {} }) => {
  return (
    <div
      className={styles.shimmer}
      style={{
        width,
        height,
        borderRadius,
        ...style,
      }}
    />
  );
};

export default Shimmer;
